import React from 'react'

// react router
import { Link } from 'react-router-dom'

// styles
import { ContentStylesContainer } from './styles/ContentStyles'

// includes
import Breadcrumbs from './Includes/Breadcrumbs'
import TearmsAndConditions from './Includes/TearmsAndConditions'
import PrivacyPolicy from './Includes/PrivacyPolicy'
import ShippingPolicies from './Includes/ShippingPolicies'
import FAQs from './Includes/FAQs'

export default function Content(props) {
    // props
    const {
        currentRoute
    } = props

    return (
        <ContentStylesContainer>
            <div className="container">
                <Breadcrumbs currentRoute={currentRoute} />

                {/* content */}
                <div className="content">
                    {/* links */}
                    <div className="links mb-2 mb-lg-3">
                        {/* link */}
                        <Link to="/content/terms" className={`link-main text-decoration-none st-fs-16 me-2 ${currentRoute.routeUrl === "terms" ? "text-black" : "text-primary"}`}>
                            Terms and conditions
                        </Link>

                        {/* link */}
                        <Link to="/content/privacy-policy" className={`link-main text-decoration-none st-fs-16 mx-2 ${currentRoute.routeUrl === "privacy-policy" ? "text-black" : "text-primary"}`}>
                            Privacy Policy
                        </Link>

                        {/* link */}
                        <Link to="/content/shipping-payment" className={`link-main text-decoration-none st-fs-16 mx-2 ${currentRoute.routeUrl === "shipping-payment" ? "text-black" : "text-primary"}`}>
                            Shipping & Payment Info
                        </Link>

                        {/* link */}
                        <Link to="/content/returns" className={`link-main text-decoration-none st-fs-16 mx-2 ${currentRoute.routeUrl === "returns" ? "text-black" : "text-primary"}`}>
                            FAQ
                        </Link>
                    </div>
            
                    {
                        currentRoute.routeUrl === "returns" ? (
                            <FAQs />
                        ) : null
                    }
                    {
                        currentRoute.routeUrl === "terms" ? (
                            <TearmsAndConditions />
                        ) : null
                    }
                    {
                        currentRoute.routeUrl === "shipping-payment" ? (
                            <ShippingPolicies />
                        ) : null
                    }
                    {
                        currentRoute.routeUrl === "privacy-policy" ? (
                            <PrivacyPolicy />
                        ) : null
                    }
                </div>
            </div>
        </ContentStylesContainer>
    )
}
